enum OrderState {
  Cancelled = 'Cancelled',
  InProgress = 'InProgress',
  OrderPlaced = 'OrderPlaced',
  Reserved = 'Reserved',
  SaleComplete = 'SaleComplete',
  None = 'None'
}

export default OrderState;
